export default {
	profileLabel: 'Account navigation',
};
